import React, { useId } from 'react'

type ValidationTooltipProps = {
  active: boolean
  message: string
  children: React.ReactNode
}

/** Persistent tooltip bubble for inline field validation (visible while `active`). */
export function ValidationTooltip({ active, message, children }: ValidationTooltipProps) {
  const tooltipId = useId()

  return (
    <div className="relative">
      {active && (
        <div
          id={tooltipId}
          role="tooltip"
          data-validation-tooltip="true"
          className="absolute bottom-full left-0 z-10 mb-1 max-w-[min(280px,100vw)] rounded-md border border-danger/40 bg-surface-default px-2 py-1.5 text-xs leading-snug text-danger shadow-md"
        >
          {message}
        </div>
      )}
      <div aria-describedby={active ? tooltipId : undefined}>{children}</div>
    </div>
  )
}
